module.exports = __webpack_public_path__ + "static/media/web_lazy-ui@2x.03be29cd.png";